// extracted by mini-css-extract-plugin
export var cancelButton = "_mb-5";
export var content = "_mb-3";
export var createButton = "_mb-6";
export var drawerContainer = "_mb-0";
export var footer = "_mb-2";
export var header = "_mb-1";
export var orderFormColumn = "_mb-4";